export default `
                                                                         
▀████▀   ▀███▀▀▀██▄███▀▀▀██▄  ▄▄█▀▀██▄                              ██   
  ██       ██    ██ ██   ▀██▄██▀    ▀██▄                            ██   
  ██       ██    ██ ██   ▄████▀      ▀██▀███  ▀███   ▄▄█▀██ ▄██▀████████ 
  ██       ██▀▀▀█▄▄ ███████ ██        ██  ██    ██  ▄█▀   ████   ▀▀ ██   
  ██     ▄ ██    ▀█ ██      ██▄      ▄██  ██    ██  ██▀▀▀▀▀▀▀█████▄ ██   
  ██    ▄█ ██    ▄█ ██      ▀██▄    ▄██▀  ██    ██  ██▄    ▄█▄   ██ ██   
██████████████████▄████▄      ▀▀████▀▀    ▀████▀███▄ ▀█████▀██████▀ ▀████
                                  ███                                    
                                   ▀████▀                                `